import {myProjectCandidates} from './MyProjectCandidates/sl'
import {myProjects} from './MyProjects/sl'

export const myProject = {
  ...myProjectCandidates,
  ...myProjects,
}
